import classNames from "classnames"
import PropTypes from "prop-types"
import React from "react"
import { Controller, useFormContext } from "react-hook-form"
import { useMarina } from "src/contexts/MarinaContext"

import Form from "src/components/Form"

import { formatCurrencyFromMinorUnits } from "src/utils/UnitConversion"

const GenerateInvoiceSelectJobsStep = ({ jobs }) => {
  const { control } = useFormContext()
  const { presentmentCurrency } = useMarina()

  return (
    <Controller
      name="selectedJobIds"
      control={control}
      rules={{
        validate: (value) =>
          (value && value.length > 0) || "Select at least one job to invoice.",
      }}
      render={({ field, fieldState }) => (
        <div className="flex flex-col gap-3">
          <p className="text-sm text-gray-600">
            Choose completed jobs to include on this invoice. You can bill
            incrementally — come back for the rest later.
          </p>

          {jobs.map((job) => {
            const checked = field.value?.includes(job.id)

            return (
              <label
                key={job.id}
                className={classNames(
                  "flex cursor-pointer items-start justify-between gap-4 rounded-lg border p-4",
                  checked ? "border-blue-500 bg-blue-50" : "hover:bg-gray-100"
                )}
              >
                <div className="flex items-start gap-3">
                  <Form.Checkbox
                    compact
                    name={`job-${job.id}`}
                    checked={!!checked}
                    onChange={(e) =>
                      field.onChange(
                        e.target.checked
                          ? [...(field.value || []), job.id]
                          : (field.value || []).filter((id) => id !== job.id)
                      )
                    }
                    labelClassName="m-0"
                  />
                  <div className="flex flex-col">
                    <span className="font-semibold text-gray-900">
                      {job.name}
                    </span>
                    {job.description && (
                      <span className="text-sm text-gray-600">
                        {job.description}
                      </span>
                    )}
                  </div>
                </div>
                <span className="whitespace-nowrap font-semibold text-gray-900">
                  {formatCurrencyFromMinorUnits({
                    amount: job.total,
                    currency: presentmentCurrency,
                  })}
                </span>
              </label>
            )
          })}

          {fieldState.error && (
            <Form.Error>{fieldState.error.message}</Form.Error>
          )}
        </div>
      )}
    />
  )
}

GenerateInvoiceSelectJobsStep.propTypes = {
  jobs: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      name: PropTypes.string.isRequired,
      description: PropTypes.string,
      total: PropTypes.number.isRequired,
    })
  ).isRequired,
}

export default GenerateInvoiceSelectJobsStep
